<template>
  <!-- Full-page Loading Overlay for Express Checkout -->
  <div v-if="isExpressCheckoutLoading" class="express-checkout-loading-overlay">
    <div class="express-loading-content">
      <div class="express-loading-spinner"></div>
      <p class="express-loading-text">Processing your payment...</p>
      <p class="express-loading-subtext">Please wait while we redirect you</p>
    </div>
  </div>

  <div class="banner inner-banner" style="overflow: hidden;text-align: center;" v-if="route.query.product != 16">
  <img src="/assets/images/banners/checkout-banner.jpg?ver=1.1.0" alt="" class="w-100 zoom-out">
</div>
  <section class="checkout-sec">
    <div class="container">
      <div class="row">
        
        <div class="col-12 title text-center">
          <h3>{{ translationText.text.checkout }}</h3>
        </div>
        <div class="col-md-7 order-md-1 order-2">
          <div class="checkout-process">
            <form>
              <div class="form-content extra-top">
                <div class="checkout-wrapper">
                  <div class="flash-sale" style="display:none;" v-if="route.query.product == 16 || route.query.product == 19"><h2>FLASH SALE! ENJOY 
                    <template v-if="route.query.product == 16">10% </template> <template v-if="route.query.product == 19"> 10% </template>OFF YOUR FIRST PURCHASE. <br />
                    VALID FOR 24 HOURS ONLY! APPLY COUPON CODE 
                    <template v-if="route.query.product == 16"><strong>SALECYM10</strong> </template> <template v-if="route.query.product == 19"> <strong>SALE10</strong> </template></h2>
                  <h6>45-Day Money-Back Guarantee. No Questions Asked.</h6>
                  </div>
                  <h2>We accept</h2>
              
             <!-- Express Payment Buttons -->
                  <div class="payment-buttons payment-buttons-top">
                    <button type="button" class="payment-button paypal" :disabled="!canUseExpressCheckout">
                      <img src="/assets/images/checkout/paypal.png?ver=1.0.2" alt="PayPal" />
                    </button>
                    <button type="button" class="payment-button gpay" :disabled="!canUseExpressCheckout">
                      <img src="/assets/images/checkout/gpay.png?ver=1.0.2" alt="Google Pay" />
                    </button>
                    <button type="button" class="payment-button apple-pay" :disabled="!canUseExpressCheckout">
                      <img src="/assets/images/checkout/apple-pay.png?ver=1.0.2" alt="Apple Pay" />
                    </button>                
                  </div>
                  
                  <!-- UnifiedExpressCheckout Component -->
                  <UnifiedExpressCheckout
                    :baseURL="props.baseURL"
                    :items="expressCheckoutItems"
                    :amount="expressCheckoutAmount"
                    :currency="expressCheckoutCurrency"
                    :country="expressCheckoutCountry"
                    :user-id="expressCheckoutUserId"
                    :shipping-address="expressCheckoutShippingAddress"
                    :merchant-name="'CymCorp International'"
                    :stripe-publishable-key="stripePublishableKey"
                    @payment-success="handleExpressPaymentSuccess"
                    @payment-error="handleExpressPaymentError"
                  />
                  
                  <div class="divider">OR</div>
                  
                  <h2>Complete checkout form below for regular checkout</h2>
            </div>
            </div>
              <div class="form-content">
                <div class="label-heading label-heading-active">
                  <h4>{{ translationText.text.contact }}</h4>
                  <div class="row" v-if="!userLogin.checkIsLoggedIn"> 
                    <a
                          href="javascript: ;"
                          v-if="isCancelBtn"
                          @click="cancelBtnclick"
                          class="link"
                          style="float: right; width: 37%; color: #989898"
                          >Cancel</a
                        >   
                    
                        <a
                          href="javascript: ;"
                          v-if="isLoginNextBtn"
                          @click="loginBtnclick"
                          class="link"
                          style="float: right; width: 37%; color: #989898"
                          >{{ translationText.text.login }}</a
                        >                        
                        <router-link
                          v-if="isLoginNextBtn"
                          :to="{ name: 'Signup' }"
                          class="link"
                          style="float: right; width: 37%; color: #989898"
                          >Registration</router-link
                        > 
                       
                      </div>
                  <!--<a
                    href="javascript: ;"
                    v-if="loginEditBtn"
                    @click="editLoginTab"
                    class="link"
                    >{{ translationText.text.edit }}</a
                  >-->
                </div>
                <div class="form-infomation">
                  <p>{{ translationText.text.email }} {{ email }}</p>
                </div>
                <template v-if="!userLogin.checkIsLoggedIn">
                  <Form novalidate @submit="signinValid" v-if="loginNextBtn">
                    <div class="form-input">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group input-icon">
                            <Field
                              type="email"
                              v-model="email"
                              name="email"
                              class="form-control"
                              rules="email|required"
                              :placeholder="translationText.text.emailText"
                            ></Field>
                            <img
                              src="/assets/images/check-full.png?ver=1.0.0"
                              alt=""
                              class="i-check"
                            />
                            <ErrorMessage name="email" />
                          </div>
                        </div>
                        <div class="col-md-8" v-if="passwordBtn != false">
                          <div class="form-group input-icon">
                            <Field
                              type="password"
                              v-model="password"
                              name="password"
                              rules="required"
                              class="form-control"
                              :placeholder="translationText.text.passwordLabel"
                            ></Field>
                            <ErrorMessage name="password" />
                          </div>
                        </div>
                      </div>                     
                    </div>
                  </Form>
                </template>
                <template v-if="passwordBtn">
                  <div class="row">
                    <button
                      type="button"
                      @click="loginFormSubmit"
                      class="btn btn-dark rc btn-checkout"
                    >
                      {{ translationText.text.login }}
                      <i class="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </template>
              </div>
              <div class="form-content">
                <div class="label-heading label-heading-active">
                  <h4>{{ translationText.text.deliveryAddress }}</h4>
                  <!--<a
                    href="javascript: ;"
                    v-if="addressEditBtn"
                    @click="addressEdit"
                    class="link"
                    >{{ translationText.text.edit }}
                  </a>-->
                </div>
                <!--<div class="form-infomation" v-if="addressEditBtn">
                  <h6>{{ translationText.text.deliveryAddress }}</h6>
                  <address>
                     {{ first_name }} {{ last_name }}
                    {{ address1 }} {{ addres2 }}, {{ city }},
                    {{ stateAddressShow }}, {{ countryAddressShow }}
                    {{ zip_code }}
                    {{ mobile }}
                  </address>
                  <div class="options-highlited" v-if="billSame">
                    {{ translationText.text.sameDelivery }}
                  </div>
                </div>-->
                <Form novalidate @submit="signinAddressValid">
                  <div class="form-input">
                    <div class="row">
                      <div class="form-group col-12">
                        <label class="field">
                          <span class="field-label" for="country"
                            >{{ translationText.text.countryLabel }} *</span
                          >
                          <!-- @change="onChangeCountry($event)" -->
                          <Field
                            rules="required"
                            v-model="country"
                            as="select"
                            class="field-input form-control"
                            name="country"
                            id="country"
                          >
                            <!-- <option value="United States (US)">United States (US)</option>
                                                <option value="Canada">Canada</option> -->
                            <template v-if="allCountries.length > 0">
                              <template
                                v-for="(allCountry, index) in allCountries"
                              >
                                <option :value="allCountry.id">
                                  {{ allCountry.name }}
                                </option>
                              </template>
                            </template>
                          </Field>
                          <ErrorMessage name="country" />
                        </label>
                      </div>
                      <div class="form-group col-md-6">
                        <Field
                          type="text"
                          rules="required"
                          v-model="first_name"
                          name="first_name"
                          class="form-control"
                          :placeholder="translationText.text.firstNameLabel"
                        ></Field>
                        <ErrorMessage name="first_name" />
                      </div>
                      <div class="form-group col-md-6">
                        <Field
                          type="text"
                          rules="required"
                          v-model="last_name"
                          name="last_name"
                          class="form-control"
                          :placeholder="translationText.text.lastNameLabel"
                        ></Field>
                        <ErrorMessage name="last_name" />
                      </div>
                      <div class="form-group col-12">
                        <Field
                          type="text"
                          rules="required"
                          v-model="address1"
                          name="address1"
                          class="form-control"
                          :placeholder="translationText.text.address1Label"
                        ></Field>
                        <ErrorMessage name="address1" />
                      </div>
                      <div class="form-group col-12">
                        <Field
                          type="text"
                          name="addres2"
                          v-model="addres2"
                          class="form-control"
                          :placeholder="translationText.text.address2Label"
                        ></Field>
                        <!-- <ErrorMessage name="addres2" /> -->
                      </div>
                      <div class="form-group col-md-4">
                        <Field
                          type="text"
                          rules="required"
                          v-model="city"
                          name="city"
                          class="form-control"
                          :placeholder="translationText.text.cityLabel"
                          @blur="submitForm"
                        ></Field>
                        <ErrorMessage name="city" />
                      </div>
                      <div class="form-group col-md-4 col-6">
                        <Field
                          as="select"
                          rules="required"
                          v-model="state"
                          class="field-input form-control"
                          name="state"
                          id="state"
                          @change="submitForm"
                        >
                          <option value="" disabled>
                            {{ translationText.text.stateLabel }}
                          </option>
                          <template v-if="allStates.length > 0">
                            <template v-for="(allState, index) in allStates">
                              <option :value="allState.id">
                                {{ allState.name }}
                              </option>
                            </template>
                          </template>
                        </Field>
                        <ErrorMessage name="state" />
                      </div>
                      <div class="form-group col-md-4 col-6">
                        <Field
                          type="text"
                          v-model="zip_code"
                          rules="required"
                          name="zip_code"
                          class="form-control"
                          :placeholder="translationText.text.zipcode"
                          @blur="submitForm"
                        ></Field>
                        <ErrorMessage name="zip_code" />
                      </div>
                      <div class="form-group col-md-8">
                        <Field
                          type="tel"
                          rules="required"
                          v-model="mobile"
                          name="mobile"
                          class="form-control"
                          :placeholder="translationText.text.phoneLabel"
                        ></Field>
                        <ErrorMessage name="mobile" />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <div class="custome_checkbox">
                        <input
                          v-model="billSame"
                          :value="true"
                          type="checkbox"
                          id="bill-address"
                          name="billSame"
                          rows="1"
                        />
                        <label for="bill-address"
                          >{{ translationText.text.myBilling }}
                          <a href="#">{{
                            translationText.text.readMore
                          }}</a></label
                        >
                        <ErrorMessage name="billSame" />
                      </div>
                    </div>
                    <div class="row" v-if="!billSame">                     
                      <div class="form-group col-12">
                        <h4>BILLING ADDRESS</h4>
                        <label class="field">
                          <span class="field-label" for="country"
                            >{{ translationText.text.countryLabel }} *</span
                          >
                          <!-- @change="onChangeCountry($event)" -->
                          <Field
                            rules="required"
                            v-model="billing_country"
                            as="select"
                            class="field-input form-control"
                            name="billing_country"
                            id="country"
                          >
                            <!-- <option value="United States (US)">United States (US)</option>
                                                <option value="Canada">Canada</option> -->
                            <template v-if="allCountries.length > 0">
                              <template
                                v-for="(allCountry, index) in allCountries"
                              >
                                <option :value="allCountry.id">
                                  {{ allCountry.name }}
                                </option>
                              </template>
                            </template>
                          </Field>
                          <ErrorMessage name="billing_country" />
                        </label>
                      </div>
                      <div class="form-group col-md-6">
                        <Field
                          type="text"
                          rules="required"
                          v-model="billing_first_name"
                          name="billing_first_name"
                          class="form-control"
                          :placeholder="translationText.text.firstNameLabel"
                        ></Field>
                        <ErrorMessage name="billing_first_name" />
                      </div>
                      <div class="form-group col-md-6">
                        <Field
                          type="text"
                          rules="required"
                          v-model="billing_last_name"
                          name="billing_last_name"
                          class="form-control"
                          :placeholder="translationText.text.lastNameLabel"
                        ></Field>
                        <ErrorMessage name="billing_last_name" />
                      </div>
                      <div class="form-group col-12">
                        <Field
                          type="text"
                          rules="required"
                          v-model="billing_address1"
                          name="billing_address1"
                          class="form-control"
                          :placeholder="translationText.text.address1Label"
                        ></Field>
                        <ErrorMessage name="billing_address1" />
                      </div>
                      <div class="form-group col-12">
                        <Field
                          type="text"
                          name="billing_addres2"
                          v-model="billing_address2"
                          class="form-control"
                          :placeholder="translationText.text.address2Label"
                        ></Field>
                        <!-- <ErrorMessage name="addres2" /> -->
                      </div>
                      <div class="form-group col-md-4">
                        <Field
                          type="text"
                          rules="required"
                          v-model="billing_city"
                          name="billing_city"
                          class="form-control"
                          :placeholder="translationText.text.cityLabel"
                        ></Field>
                        <ErrorMessage name="billing_city" />
                      </div>
                      <div class="form-group col-md-4 col-6">
                        <Field
                          as="select"
                          rules="required"
                          v-model="billing_state"
                          class="field-input form-control"
                          name="billing_state"
                          id="billing_state"
                        >
                          <option value="" disabled>
                            {{ translationText.text.stateLabel }}
                          </option>
                          <template v-if="allStates.length > 0">
                            <template v-for="(allState, index) in allStates">
                              <option :value="allState.id">
                                {{ allState.name }}
                              </option>
                            </template>
                          </template>
                        </Field>
                        <ErrorMessage name="billing_state" />
                      </div>
                      <div class="form-group col-md-4 col-6">
                        <Field
                          type="text"
                          v-model="billing_zip_code"
                          rules="required"
                          name="billing_zip_code"
                          class="form-control"
                          :placeholder="translationText.text.zipcode"
                        ></Field>
                        <ErrorMessage name="billing_zip_code" />
                      </div>
                      <div class="form-group col-md-8">
                        <Field
                          type="tel"
                          rules="required"
                          v-model="billing_mobile"
                          name="billing_mobile"
                          class="form-control"
                          :placeholder="translationText.text.phoneLabel"
                        ></Field>
                        <ErrorMessage name="billing_mobile" />
                      </div>
                    </div>                    
                    <div class="form-group col-12">
                      <div class="custome_checkbox">
                        <Field
                          v-model="stayup"
                          :value="true"
                          type="checkbox"
                          id="stayup"
                          name="stayup"
                          rows="1"
                        ></Field>
                        <label for="stayup"
                          >{{ translationText.text.likeStay }}
                          <a href="#">{{
                            translationText.text.readMore
                          }}</a></label
                        >
                        <ErrorMessage name="stayup" />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <div class="custome_checkbox">
                        <Field
                          :value="true"
                          v-model="terms"
                          rules="required"
                          type="checkbox"
                          name="terms"
                          id="terms"
                          rows="1"
                        ></Field>
                        <label for="terms"
                          >{{ translationText.text.yes18 }}
                          <a href="#">{{ translationText.text.termsText }}</a>
                          {{ translationText.text.andtext }}
                          <a href="#">{{
                            translationText.text.privacyPolicy
                          }}</a
                          >*</label
                        >
                        <ErrorMessage name="terms" />
                      </div>
                    </div>
                    
                  </div>
                  <button
                  v-if="userLogin.checkIsLoggedIn"
                  type="submit"
                  class="btn btn-dark rc"
                >
                  {{ translationText.text.getshipping }}
                  <i class="ri-arrow-right-line"></i>
                  </button>                 
                </Form>               
              </div>
             
              <div class="form-content">
                <div class="label-heading label-heading-active">
                  <h4>{{ translationText.text.deliveryOption }}</h4>                                 
                </div>
                <div class="options-highlited">
                      {{ translationText.text.deliveryOptionInfo }}
                    </div> 
                <template v-if="state">
                  <div class="form-infomation" style="display:none;">
                    <div class="options-highlited">
                      {{ translationText.text.payOnline }}
                    </div>
                    <div v-if="isCanada" class="options-highlited">
                      <h3>{{ translationText.text.delivery_notification }}</h3>
                    {{ translationText.text.shipping_delivery_information }}
                    </div>

                  </div>
                  <Form novalidate @submit="deliveryOption">
                    <!-- <template v-if="shippingOptions.length > 0"> -->
                    <template
                      v-for="(shippingOption, index) in shippingOptions"
                    >
                      <div class="delivery-box">
                        <!-- Standard Delivery -->
                        <Field
                          rules="required"
                          @change="getShippingName(shippingOption)"
                          v-model="shippingType"
                          :value="shippingOption.rate"
                          type="radio"
                          name="shippingType"
                        ></Field>
                        <i class="ri-truck-line"></i>
                        <h6>${{ shippingOption.rate }} &nbsp; {{ shippingOption.carrier }}</h6>
                      </div>
                    </template>
                    <ErrorMessage name="shippingType" />
                   
                  </Form>
                </template>
              </div>
              <div ref="paymentSection">
              <Payment                
                :baseURL="props.baseURL"
                :translationText="translationText"
                :email="email"
                :password="password"
                :country="country"
                :first_name="first_name"
                :last_name="last_name"
                :address1="address1"
                :addres2="addres2"
                :city="city"
                :state="state"
                :zip_code="zip_code"
                :mobile="mobile"
                :billSame="billSame"
                :billing_first_name="billing_first_name"
                :billing_last_name="billing_last_name"
                :billing_address1="billing_address1"
                :billing_address2="billing_address2"
                :billing_city="billing_city"
                :billing_state="billing_state"
                :billing_zip_code="billing_zip_code"
                :billing_mobile="billing_mobile"
                :billing_country="billing_country"
                :stayup="stayup"
                :terms="terms"
                :shippingType="shippingType"
                :shippingTypeName="shippingTypeName"
              ></Payment>
              </div>
            </form>
          </div>
        </div>
        <CheckoutProductReview
          :translationText="translationText"
          :baseURL="props.baseURL"
        ></CheckoutProductReview>

     
        
      </div>
      <div class="col-md-12 order-md-1 order-2" v-if="route.query.product != 16">
          <section class="products-area">
            <div class="container">
                <div class="row justify-content-center" data-aos="fade-up">
                    <div class="title col-lg-8 text-center">
                        <h2>Customers who bought this product also bought</h2>                
                    </div>
                </div>
                <div class="flex-holistic">

                    <template v-for="(holistic,index) in holistic.products">
                        <div class="single-product-box">
                          <div class="product-image">
                              <img :src="holistic.thumbnail_url" alt="" class="img-responsive">
                              <img :src="holistic.images_url[0]" alt="" class="w-100 hover-gallery-image">
                              <!-- <a class="quick-view">QUICK VIEW</a> -->
                              <router-link
                              class="quick-view"
                              :to="{ name: 'ShowDetails', params: { id: holistic.id } }"
                              >{{ translationText.text.quickView }}</router-link
                            >
                          </div>
                          <div class="product-dtls">               
                              <h3>
                                <router-link
                              
                              :to="{ name: 'ShowDetails', params: { id: holistic.id } }"
                              >{{ holistic.name }}</router-link
                            >

                              </h3>
                              <p class="actual-price">
                              <del>${{ holistic.sale_price }}</del>
                              ${{ holistic.suggested_retail_price }}</p>
                              <!-- <p class="discount-price">For valued Scholar: $43.60</p> -->
                          </div>
                      </div>

                    </template>
                  
                    
                </div>
            </div>  
          </section>
      </div>

    </div>
  </section>
</template>

<script setup>
import { ref, computed, defineProps, watch, onMounted, watchEffect, nextTick } from "vue";
import { Form, Field, ErrorMessage, defineRule, configure } from "vee-validate";

import { mapState, storeToRefs } from "pinia";
import { useLoginStore } from "../../stores/login";
import { useCartStore } from "../../stores/cart";
import Payment from "../../components/Checkout/Payment";
import CheckoutProductReview from "../../components/Checkout/CheckoutProductReview";
import { useRouter, useRoute, onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router";
import PasswordMeter from "vue-simple-password-meter";
//import { required, between, confirmed,email } from '@vee-validate/rules';
import * as AllRules from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import { userLanguage } from "../../stores/language";
import axios from "axios";
// ADD THIS IMPORT - UnifiedExpressCheckout Integration
import UnifiedExpressCheckout from "../../components/Checkout/UnifiedExpressCheckout";

const props = defineProps(["baseURL"]);
Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});
const cartData = useCartStore();
const userLogin = useLoginStore();
const userLanguages = userLanguage();
const { languageCode } = storeToRefs(userLanguages);

const { loginToken } = storeToRefs(userLogin);

const showPopup = ref(false);
const hasClosedPopup = ref(false);

const router = useRouter();
const route = useRoute();

// BOGO (Buy One Get One) Configuration
// Add product IDs that are eligible for the BOGO offer
const BOGO_ELIGIBLE_PRODUCTS = [1, 6]; // You can add more product IDs here

const holistic = ref({
    products: [],
  });

const headers = {
  Authorization: "Bearer " + userLogin.loggedToken,
};

const isCanada = computed(() => {
  const selectedCountry = allCountries.value.find((c) => c.id === country.value);
  return selectedCountry && selectedCountry.name.toLowerCase() === "canada";
});

// Show popup after 15 seconds when the page loads
onMounted(() => {
  // Clear tax if no state is selected on page load
  // This handles cases where tax was persisted from a previous session
  if (!state.value || state.value === "") {
    cartData.clearTax();
    console.log("Checkout mounted: No state selected, tax cleared");
  }

  if (!sessionStorage.getItem('exitPopupClosed')) {
    setTimeout(() => {
      const productParam = route.query.product;
      if (productParam == '16' || productParam == 16) {
        showPopup.value = false;
      }
   }, 20000);
  }

});

const closePopup = () => {
  showPopup.value = false;
  hasClosedPopup.value = true;
  sessionStorage.setItem('exitPopupClosed', 'true'); 
};

watch(showPopup, (newValue) => {
 if (newValue) {
  const productParam = route.query.product;
      if (productParam == '16' || productParam == 16) {
        //window.$("#exitModal").modal("show");
      }
  }
});



configure({
  generateMessage: localize({
    en: {
      messages: {
        required: "This field is required",
      },
      fields: {
        email: {
          required: "Email address is required",
          email: "Please enter a valid email address.",
        },
        password: {
          required: "Password is required",
        },
        country: {
          required: "Select country",
        },
        state: {
          required: "Select state/province",
        },
      },
    },
  }),
});




const isNewGuestCheckout = computed(() => route.query.type === 'guest');

const isLoginBtnclick = ref(false);
const isCancelBtn = ref(false);
const passwordBtn = ref(false);
const loginNextBtn = ref(true);
const addressNextBtn = ref(false);
const deliveryNextBtn = ref(false);
const paymentParentNextBtn = ref(false);
const placeOrderBtn = ref(false);

const loginEditBtn = ref(false);
const addressEditBtn = ref(false);
const deliveryEditBtn = ref(false);
const isLoginNextBtn = ref(true);

const isLoginAfterNextBtn = ref(true);

const password = ref();
const email = ref();
const country = ref("");
const first_name = ref();
const last_name = ref();
const address1 = ref();
const addres2 = ref();
const city = ref();
const state = ref("");
const zip_code = ref();
const mobile = ref();
const billing_country = ref("");
const billing_first_name = ref();
const billing_last_name = ref();
const billing_address1 = ref();
const billing_address2 = ref();
const billing_city = ref();
const billing_state = ref("");
const billing_zip_code = ref();
const billing_mobile = ref();

const stayup = ref();
const terms = ref();
const billSame = ref(true);
const allStates = ref([]);
const allCountries = ref([]);
const shippingOptions = ref([]);

const shippingType = ref();
const shippingTypeName = ref();

const countryAddressShow = ref();
const stateAddressShow = ref();

const defaultLanguage = ref("");

const headerNavigation = ref([]);
const siteLanguage = ref([]);

// Geolocation for currency detection
const detectedCountry = ref(null);
const detectedCurrency = ref('USD'); // Default to USD

cartData.emptyShippingRate();

const loginBtnclick = async () => {
  passwordBtn.value = true;
  isLoginBtnclick.value = true;
  isLoginNextBtn.value = false;
  isCancelBtn.value = true;
};

const cancelBtnclick = async () => {
  passwordBtn.value = false;
  isLoginBtnclick.value = true;
  isLoginNextBtn.value = true;
  isCancelBtn.value = false;
};
const deliveryEdit = async () => {
  console.log("inside address");
  deliveryNextBtn.value = true;
  addressEditBtn.value = false;
};

const addressEdit = async () => {
  console.log("inside address");
  addressNextBtn.value = true;
  deliveryEditBtn.value = false;
};
const editLoginTab = async () => {
  console.log("inside address");
  loginNextBtn.value = true;
  loginEditBtn.value = false;
  isLoginBtnclick.value = false;
  isLoginNextBtn.value = true;
  passwordBtn.value = false;
};

const deliveryOption = async () => {
  console.log("shippingType.value", shippingType.value);
  if (shippingType.value !== null && shippingType.value !== undefined && shippingType.value !== "") {
    console.log("inside address");
    addressNextBtn.value = false;
    deliveryNextBtn.value = false;
    paymentParentNextBtn.value = true;
    deliveryEditBtn.value = true;
    console.log(shippingType.value);
    cartData.addShippingRate(shippingType.value);
  } else {
    swal({
      position: "top-end",
      icon: "error",
      title: "Please select shipping method",
      button: false,
      timer: 2500,
    });
  }
};
const submitForm = () => {
  signinAddressValid();
};

const loginFormSubmit = () => {
    signinValid();
};

const signinAddressValid = async () => {
  const indexCountry = allCountries.value.findIndex(
    (product) => product.id == country.value
  );

  const indexState = allStates.value.findIndex(
    (product) => product.id == state.value
  );

  console.log("indexCountry", indexCountry);
  console.log("indexCountry shortname", allCountries.value[indexCountry]?.shortname);
  console.log("indexState", indexState);

  const freeShippingProductIds = [];
  const cartItems = cartData.getCartItems;

  const qualifiesForFreeShipping =
    cartItems.length > 0 &&
    cartItems.every((item) =>
      freeShippingProductIds.includes(item.id)
    );
  const hasAutoshipItems = cartData.getCartPurchaseType;


  const shippingPayLoads = ref({
    firstName: first_name.value,
    lastName: last_name.value,
    to_zip: zip_code.value,
    to_country: allCountries.value[indexCountry]?.shortname,
    to_street: address1.value + " " + addres2.value,
    to_city: city.value,
    to_state: allStates.value[indexState]?.name,
    currency: userLogin.getUserCountry == "Canada" ? "CAD" : "USD",
    qty: cartItems.length,
    product: cartItems,
  });

  // 🔧 Use `let` for conditional assignment
  let endpointUrl = "";

  if (qualifiesForFreeShipping) {
    const countryCode = allCountries.value[indexCountry]?.shortname;
    endpointUrl = countryCode === "CA" || countryCode === "US"
      ? "shipping-rates-free"
      : "shipping-rates-new";
  } else if(hasAutoshipItems) {
    const countryCode = allCountries.value[indexCountry]?.shortname;
    endpointUrl = countryCode === "CA" || countryCode === "US"
      ? "shipping-rates-free"
      : "shipping-rates-new";
  } else {
    if(cartData.getCartPurchaseType) {
      endpointUrl = "shipping-rates-new";
    } else {
      endpointUrl = "shipping-rates-new";
    }    
  }

  console.log("shippingPayLoads", shippingPayLoads.value);

  axios
    .post(props.baseURL + endpointUrl, shippingPayLoads.value)
    .then((response) => {
      console.log("shipping data", response.data);
      if (response.data.shipping_rates.length > 0) {
        shippingOptions.value = response.data.shipping_rates;
        addressNextBtn.value = false;
        deliveryNextBtn.value = true;
        addressEditBtn.value = true;
        cartData.emptyShippingRate();
        shippingType.value = null;
        
      } else {
        swal({
          position: "top-end",
          icon: "error",
          title: "No Shipping Method found. Please change address.",
          button: false,
          timer: 2500,
        });
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });

  console.log("inside address");
};

const fetchDataFromAPIHolistic  = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
  const apiUrl = props.baseURL + "products/holistic" + reqUserType + languageUrl;
  //const apiUrl = "https://cymcorp.us/management/api/v1/" + "products/holistic" + reqUserType + languageUrl;
  
  //
  console.log("home product api url ", apiUrl);
  axios
    .get(apiUrl)
    .then((response) => {
      holistic.value = response.data;
      console.log(response.data);
      //console.log("product data",this.products.products.length);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};


const afterLoginNext = async () => {
  addressNextBtn.value = true;
  isLoginAfterNextBtn.value = false;
};

const guestCheckout = async () => {
  addressNextBtn.value = true;
  loginNextBtn.value = false;
  loginEditBtn.value = true;
};
const signinValid = async () => {
    const user = {
    email: email.value,
    password: password.value,
  };
  if (!user.email || !user.password) {
    console.log('Email or password is missing.');
    return false;
  }

  await axios
    //.post(`${props.baseURL}auth/login`, user)
    .post(props.baseURL + "login", user, {
      validateStatus: function (status) {
        return status < 500; // Resolve only if the status code is less than 500
      },
    })
    .then((res) => {
      console.log("response ", res.data);
      if (res.data.errors) {
        swal({
          position: "top-end",
          icon: "error",
          title: res.data.message,
          button: false,
          timer: 2500,
        });
      } else {
        userLogin.userLoggedIn(res.data);
        addressNextBtn.value = true;
        loginNextBtn.value = false;
        loginEditBtn.value = true;
       
       
      }

      
    })
    .catch((err) => {
      
    })
    .finally(() => {
      //loading = false;
    });
};

const getCountry = async () => {
  axios
    .get(props.baseURL + "countries")
    .then((response) => {
      allCountries.value = response.data.countries;
      console.log("country  data", response.data.countries);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};
let isPageReloaded = false; 
//Add to cart functionality
const addProductToCart = async (productId) => {
  if (isPageReloaded) return; 
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
    const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
  try {
    // Fetch product data from the API
    const response = await axios.get(`${props.baseURL}product/${productId}${reqUserType}${languageUrl}`);
    const products = response.data.products;

    // Find the product by ID
    const product = products.find((prod) => prod.id === parseInt(productId));

    if (product) {
      // Access current cart items safely (considering Vue's reactivity)
      cartData.resetAllData();
      const currentCartItems = Array.isArray(cartData.getCartItems)
        ? cartData.getCartItems
        : cartData.getCartItems.value || [];

      console.log("Current cart items (debug):", currentCartItems);

      // Check if the product already exists in the cart
      const existingCartItem = currentCartItems.find(
        (item) => item.id === product.id
      );

      if (existingCartItem) {
        console.log(`Product ${productId} (${product.name}) is already in the cart.`);
        return; // Prevent adding the same product again
      }

      // Check if double parameter is true AND product is BOGO-eligible
      const isDoubleOffer = route.query.double === 'true' && BOGO_ELIGIBLE_PRODUCTS.includes(parseInt(productId));

      // For Buy 2 Get 1 Free offer: set quantity to 3, but price to 2/3 so total = 2 items price
      // Example: $90 product -> 3 items × $60 = $180 (pay for 2, get 1 free)
      const itemQuantity = isDoubleOffer ? 3 : 1;
      const itemPrice = isDoubleOffer ? (product.sale_price * 2) / 3 : product.sale_price;

      // Log if product is not eligible for Buy 2 Get 1 Free
      if (route.query.double === 'true' && !BOGO_ELIGIBLE_PRODUCTS.includes(parseInt(productId))) {
        console.log(`Product ${productId} is not eligible for Buy 2 Get 1 Free offer`);
      }

      // Prepare the cart item object
      const cartItem = {
        id: product.id,
        name: product.name,
        sale_price: itemPrice, // Adjusted price for BOGO
        price: itemPrice, // Adjusted price for BOGO
        description: product.short_description,
        image: product.images_url.length > 0 ? product.images_url[0] : "",
        hoverImage: product.thumbnail_url,
        quantity: itemQuantity, // Set quantity to 2 if BOGO offer is active
        purchaseType: product.purchaseType || 1,
        isBogoOffer: isDoubleOffer, // Flag to identify BOGO items
        originalPrice: product.sale_price, // Store original price for reference
      };

      // Add the new product to the cart
      cartData.addToCart(cartItem);
      console.log(`Product ${productId} (${product.name}) added to the cart with quantity: ${cartItem.quantity}`);
      if (isDoubleOffer) {
        console.log('Buy 2 Get 1 Free offer applied - Quantity: 3, Price per item: $' + itemPrice.toFixed(2) + ', Total: $' + (product.sale_price * 2).toFixed(2) + ' (Pay for 2, Get 1 Free)');
      }
      isPageReloaded = true;
     
    } else {
      console.error(`Product with ID ${productId} not found.`);
    }
  } catch (error) {
    console.error("Error adding product to cart:", error);
  }
};





const translationTextEn = ref({
  text: {
    checkout: "Checkout",
    emailText: "Email address *",
    contact: "Contact",
    email: "Email",
    login: "Login",
    guestCheckout: "Guest Checkout",
    registration: "Registration",
    address: "Address",
    deliveryOption: "Delivery Options",
    deliveryOptionInfo: "Shipping charges will be calculated and displayed after you enter the delivery address.",
    payment: "Payment",

    edit: "Edit",
    next: "Next",
    getshipping: "Get Price",
    payOnline:
      "Pay Online for Faster Delivery and Faster Return/Refund. Please allow up to one extra day for packaging and handling.",
    deliveryWithin: "Estimate ",
    days: "Day(s) delivery",
    myBilling: "My billing and delivery information are the same.",
    readMore: "Read more",
    likeStay: "I would like to stay up to date with Cymcorp International.",
    yes18: "Yes, I am over 18 years old & accept the",
    andtext: "And",
    privacyPolicy: "Privacy Policy.",
    deliveryAddress: "Delivery address",
    sameDelivery: "Your delivery and billing address are the same",
    countryLabel: "Country",
    emailLabel: "Email Address",
    ambassadorLabel: "As an Ambassador: Create your own...",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    strengthLabel: "Strength",
    securityLabel: "Select Security Question",
    answerLabel: "Answer",
    selectLabel: "Select an option",
    SSNLabel: "Numbers Only, No Dashes",
    languageLabel: "Select Language",
    currencyLabel: "Default Currency",
    firstNameLabel: "First Name *",
    lastNameLabel: "Last Name *",
    phoneLabel: "Mobile Number *",
    birthLabel: "Birth Date",
    monthSelectLabel: "Select Month",
    dateSelectLabel: "Select Date",
    yearSelectLabel: "Select Year",
    yesSendLabel: "YES! SEND ME E-MAIL NOTICES & UPDATES",
    enrollmentSummaryLabel: "Enrollment Summary",
    countryBillillingAddressLabel: "Billing Address",
    address1Label: "Address line 1 *",
    address2Label: "Address line 2",
    cityLabel: "City *",
    countryLabel: "Country",
    stateLabel: "Select state/province",
    contrySelectLabel: "Select country",
    agreements: "Agreements",
    termsText: "Terms & Conditions",
    termsTextContent:
      'I have read and agree to the Terms and Conditions of this website. Clicking the "Place Order Now" button will submit my order for processing. I may cancel this purchase within 30 days for a full refund by eMailing support@cymcorp.ca or contacting Customer Service at',
    stateLabel1: "State",
    shippingAddressLabel: "Shipping Address",
    zipcode: "Zip Code*",
    sameAsBillingAddress: "Same As Billing Address",
    signUp: "Sign Up",
    creditCard: "Credit/Debit Cards",
    paypalCard: "Paypal",
    apply: "Apply",
    total: "Total",
    codeApplied: "Coupon Code Applied",
    subtotal: "Subtotal",
    netShipping: "Net Shipping",
    shippingTax: "Shipping Tax", 
    shipping_tax: "Shipping Tax", 
    tax: "Tax",
    volumeSummary: "Volume Summary",
    monthlyPE: "Total Monthly PE",
    enterCode: "Enter Coupon Code",
    paymentSsl:
      "Payments are SSL encrypted so that your credit card and payment details stay safe.",
    cardNumber: "Card number",
    expiration: "Expiration",
    cvv: "cvv",
    placeOrder: "Place Order",
    delivery_notification: "Notice for Canada Deliveries",
    shipping_delivery_information: "Due to the ongoing Canada Post strike, our logistics warehouse is committed to using alternative shipping companies to ensure your orders reach you. As we enter a high-volume season, please anticipate a slight delay in deliveries. We greatly appreciate your understanding and are doing everything possible to provide a seamless experience during this period.",
    exit_popup_wait_msg: "Wait! Use coupon code 10OFF to unlock an additional 10% discount on your FIRST ORDER! Click OK to claim your discount now.",
    guranteeText:"100% money back! No questions asked.",
    chksidebarTitle: "Why Choose CymCorp?",
    chksidebarPoint1: "1. 45-Day Money-Back Guarantee:",
    chksidebarPoint2: "Try CymCorp with confidence. Incorporate it into your daily routine and if you’re not completely satisfied, we’ll issue a full refund within 45 days.Your satisfaction is our priority.",
    chksidebarPoint3: "2. Trusted by Over 652,035 Happy Customers:",
    chksidebarPoint4: "Join a growing community of health-conscious individuals who swear by CymCorp.Our commitment to quality and care is reflected in the results our customers experience and love.",
    chksidebarPoint5: "3. Need Help? We're Here for You:",
    chksidebarPoint6: "Have questions or need support regarding your order? Contact our friendly customer care team at:",
    chksidebarPoint7: "1-888-968-3592 (Toll-Free)",
    chksidebarPoint8: "We’re always happy to assist you!",
    quickView: "QUICK VIEW",
  },
  language: "",
});


const translationText = ref({
  text: {
    checkout: "Checkout",
    emailText: "Email address *",
    contact: "Contact",
    email: "Email",
    login: "Login",
    guestCheckout: "Guest Checkout",
    registration: "Registration",
    address: "Address",
    deliveryOption: "Delivery Options",
    deliveryOptionInfo: "Shipping charges will be calculated and displayed after you enter the delivery address.",
    payment: "Payment",

    edit: "Edit",
    next: "Next",
    getshipping: "Get Price",
    payOnline:
      "Pay Online for Faster Delivery and Faster Return/Refund. Please allow up to one extra day for packaging and handling.",
    deliveryWithin: "Estimate ",
    days: "Day(s) delivery",
    myBilling: "My billing and delivery information are the same.",
    readMore: "Read more",
    likeStay: "I would like to stay up to date with Cymcorp International.",
    yes18: "Yes, I am over 18 years old & accept the",
    andtext: "And",
    privacyPolicy: "Privacy Policy.",
    deliveryAddress: "Delivery address",
    sameDelivery: "Your delivery and billing address are the same",
    countryLabel: "Country",
    emailLabel: "Email Address",
    ambassadorLabel: "As an Ambassador: Create your own...",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    strengthLabel: "Strength",
    securityLabel: "Select Security Question",
    answerLabel: "Answer",
    selectLabel: "Select an option",
    SSNLabel: "Numbers Only, No Dashes",
    languageLabel: "Select Language",
    currencyLabel: "Default Currency",
    firstNameLabel: "First Name *",
    lastNameLabel: "Last Name *",
    phoneLabel: "Mobile Number *",
    birthLabel: "Birth Date",
    monthSelectLabel: "Select Month",
    dateSelectLabel: "Select Date",
    yearSelectLabel: "Select Year",
    yesSendLabel: "YES! SEND ME E-MAIL NOTICES & UPDATES",
    enrollmentSummaryLabel: "Enrollment Summary",
    countryBillillingAddressLabel: "Billing Address",
    address1Label: "Address line 1 *",
    address2Label: "Address line 2",
    cityLabel: "City *",
    countryLabel: "Country",
    stateLabel: "Select state/province",
    contrySelectLabel: "Select country",
    agreements: "Agreements",
    termsText: "Terms & Conditions",
    termsTextContent:
      'I have read and agree to the Terms and Conditions of this website. Clicking the "Place Order Now" button will submit my order for processing. I may cancel this purchase within 30 days for a full refund by eMailing support@cymcorp.ca or contacting Customer Service at',
    stateLabel1: "State",
    shippingAddressLabel: "Shipping Address",
    zipcode: "Zip Code*",
    sameAsBillingAddress: "Same As Billing Address",
    signUp: "Sign Up",
    creditCard: "Credit/Debit Cards",
    paypalCard: "Paypal",
    apply: "Apply",
    total: "Total",
    codeApplied: "Coupon Code Applied",
    subtotal: "Subtotal",
    netShipping: "Net Shipping",
    shippingTax: "Shipping Tax", 
    shipping_tax: "shipping_tax", 
    tax: "Tax",
    volumeSummary: "Volume Summary",
    monthlyPE: "Total Monthly PE",
    enterCode: "Enter Coupon Code",
    paymentSsl:
      "Payments are SSL encrypted so that your credit card and payment details stay safe.",
    cardNumber: "Card number",
    expiration: "Expiration",
    cvv: "cvv",
    placeOrder: "Place Order",
    delivery_notification: "Notice for Canada Deliveries",
    shipping_delivery_information: "Due to the ongoing Canada Post strike, our logistics warehouse is committed to using alternative shipping companies to ensure your orders reach you. As we enter a high-volume season, please anticipate a slight delay in deliveries. We greatly appreciate your understanding and are doing everything possible to provide a seamless experience during this period.",
    exit_popup_wait_msg: "Wait! Use coupon code 10OFF to unlock an additional 10% discount on your FIRST ORDER! Click OK to claim your discount now.",
    guranteeText:"100% money back! No questions asked.",
    chksidebarTitle: "Why Choose CymCorp?",
    chksidebarPoint1: "1. 45-Day Money-Back Guarantee:",
    chksidebarPoint2: "Try CymCorp with confidence. Incorporate it into your daily routine and if you’re not completely satisfied, we’ll issue a full refund within 45 days.Your satisfaction is our priority.",
    chksidebarPoint3: "2. Trusted by Over 652,035 Happy Customers:",
    chksidebarPoint4: "Join a growing community of health-conscious individuals who swear by CymCorp.Our commitment to quality and care is reflected in the results our customers experience and love.",
    chksidebarPoint5: "3. Need Help? We're Here for You:",
    chksidebarPoint6: "Have questions or need support regarding your order? Contact our friendly customer care team at:",
    chksidebarPoint7: "1-888-968-3592 (Toll-Free)",
    chksidebarPoint8: "We’re always happy to assist you!",
    quickView: "QUICK VIEW",
  },
  language: "",
});

const translatText = () => {
  
  translationText.value.language = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";

  if(userLanguages.getLanguageCode != 'en'){
    const apiUrl = props.baseURL + "translateany";
    axios
      .post(apiUrl, translationText.value)
      .then((response) => {
        console.log("response trnasate :", response.data);
        translationText.value = response.data;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }
  else{
    translationText.value = translationTextEn.value;
  }
  
};

const getUserAddress = () => {
  // console.log(props.baseURL);
  // const languageUrl = userLanguages.getLanguageCode
  //   ? "/" + userLanguages.getLanguageCode
  //   : "";

  const apiUrl = props.baseURL + "user/address/shipping";
  axios
    .get(apiUrl, { headers })
    .then((response) => {
      console.log(
        "response user/address/shipping :",
        response.data.shipping_address
      );
      //translationText.value = response.data;
      if (response.data.shipping_address) {
        country.value = response.data.shipping_address.country;
        first_name.value = userLogin.getUserUserData.firstname;
        last_name.value = userLogin.getUserUserData.lastname;
        address1.value = response.data.shipping_address.address1;
        addres2.value = response.data.shipping_address.address2;
        city.value = response.data.shipping_address.city;
        state.value = response.data.shipping_address.state;
        zip_code.value = response.data.shipping_address.zip_code;
        mobile.value = response.data.shipping_address.mobile;
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getShippingName = (shippinVal) => {
  console.log("shippinVal.carrier shippinVal==", shippinVal);
  shippingTypeName.value = shippinVal.carrier;
  console.log("shippinVal.carrier", shippinVal.carrier);
  deliveryOption();
  cartData.addShippingRate(shippinVal.rate);
};

const getLanguage = async () => {
  await axios
    .get(`${props.baseURL}languages`)
    //.get(apiUrl)
    .then((res) => {
      console.log("response ", res.data);
      siteLanguage.value = res.data.languages;

      if (userLanguages.getLanguageCode == null) {
        if (res.data.languages.length > 0) {
          res.data.languages.forEach((language) => {
            if (language.is_default == 1) {
              userLanguages.setLanguage(language);
              console.log("language", language);
              defaultLanguage.value = language.code;
            }
          });
        }
      }
    })
    .catch((err) => {
      //   swal({
      //     text: "Unable to Log you in!",
      //     icon: "error",
      //     closeOnClickOutside: false,
      //   });
      console.log(err);
    })
    .finally(() => {
      //loading = false;
    });
};
//get Header
let isHeaderFetched = false;
const getHeader = async () => {
  if (isHeaderFetched) return;
  isHeaderFetched = true;

  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl = props.baseURL + "navigations/header" + languageUrl;
  await axios
    .get(apiUrl)
    .then((res) => {
      console.log("response ", res.data);
      headerNavigation.value = res.data.navigations;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
    });
};

// Detect country via IP geolocation
const detectCountryByIP = async () => {
  try {
    console.log('🌍 [GEOLOCATION] Detecting country via IP...');
    const response = await axios.get(props.baseURL + "detect-country");

    if (response.data) {
      detectedCountry.value = response.data.country_code;
      detectedCurrency.value = response.data.currency;

      console.log('🌍 [GEOLOCATION] Country detected:', {
        detected_ip: response.data.detected_ip,
        country: response.data.country_name,
        code: response.data.country_code,
        currency: response.data.currency,
        is_localhost: response.data.is_localhost,
        full_response: response.data
      });

      // Log to console in BIG letters so you can see it easily
      console.log('%c🌍 DETECTED CURRENCY: ' + response.data.currency, 'background: #222; color: #bada55; font-size: 20px; padding: 10px;');
      console.log('%c🌍 DETECTED COUNTRY: ' + response.data.country_name + ' (' + response.data.country_code + ')', 'background: #222; color: #bada55; font-size: 20px; padding: 10px;');
      console.log('%c🌍 DETECTED IP: ' + response.data.detected_ip, 'background: #222; color: #bada55; font-size: 20px; padding: 10px;');

      return response.data;
    }
  } catch (error) {
    console.error('🌍 [GEOLOCATION] Error detecting country:', error);
    // Default to USD on error
    detectedCountry.value = 'US';
    detectedCurrency.value = 'USD';
  }
};

const addTrackingScript = () => {
  // Load Google Tag Manager script
  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-16857523017";
  document.head.appendChild(gtagScript);

  // Initialize gtag function and configuration
  const gtagInitScript = document.createElement("script");
  gtagInitScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-16857523017');
  `;
  document.head.appendChild(gtagInitScript);

  // Add the conversion event script
  const gtagEventScript = document.createElement("script");
  gtagEventScript.innerHTML = `
    gtag('event', 'conversion', {
      'send_to': 'AW-16857523017/Oa1dCJ6qqpoaEMnGpeY-',
      'value': 1.0,
      'currency': 'USD',
      'transaction_id': ''
    });
  `;
  document.body.appendChild(gtagEventScript);

  //gTag for product 15
  const gtagScriptOne = document.createElement("script");
  gtagScriptOne.async = true;
  gtagScriptOne.src = "https://www.googletagmanager.com/gtag/js?id=AW-870466601";
  document.head.appendChild(gtagScriptOne);

  // Initialize gtag function and configuration
  const gtagOneInitScript = document.createElement("script");
  gtagOneInitScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-870466601');
  `;
  document.head.appendChild(gtagOneInitScript);

// Add the conversion event script
const gtagOneEventScript = document.createElement("script");
  gtagEventScript.innerHTML = `
    gtag('event', 'conversion', {
      'send_to': 'AW-870466601/93CtCMLA2bIaEKmIiZ8D',
      'value': 1.0,
      'currency': 'CAD'
    });
  `;
  document.body.appendChild(gtagOneEventScript);

  
  const heatMapScript = document.createElement("script");
  heatMapScript.innerHTML = `
     (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "qauem33ql6");
  `;
  document.head.appendChild(heatMapScript);

  const gtagScriptNew = document.createElement("script");
  gtagScriptNew.innerHTML = `
  gtag('event', 'conversion', {
      'send_to': 'AW-870466601/93CtCMLA2bIaEKmIiZ8D',
      'value': 1.0,
      'currency': 'CAD'
  });`;
  document.head.appendChild(gtagScriptNew);

  const clarityScriptNew = document.createElement("script");
  clarityScriptNew.innerHTML = `
  (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "qauem33ql6");`;
  document.head.appendChild(clarityScriptNew);  
  console.log("Firing GTAG conversion event");

  const gtagScriptNewSec = document.createElement("script");
  gtagScriptNew.innerHTML = `
  gtag('event', 'conversion', {
      'send_to': 'AW-16857523017/Oa1dCJ6qqpoaEMnGpeY-',
      'value': 1.0,
      'currency': 'CAD',
      'transaction_id': ''
  });`;
  document.head.appendChild(gtagScriptNewSec);


};

const addFacebookPixel = () => {
  // Load the FB Pixel script dynamically
  const fbScript = document.createElement("script");
  fbScript.async = true;
  fbScript.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(fbScript);

  // Initialize FB Pixel
  const fbInitScript = document.createElement("script");
  fbInitScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('track', 'InitiateCheckout');
  `;
  document.head.appendChild(fbInitScript);

  console.log("Facebook Pixel initialized");
};





watch(country, (newValue, oldValue) => {
  console.log("countrt selected");

  // Clear state selection and tax when country changes
  if (oldValue && oldValue !== newValue) {
    state.value = "";
    cartData.clearTax();
    console.log("Country changed, state and tax cleared");
  }

  if (allCountries.value.length > 0) {
    let countryIndex = allCountries.value.findIndex(
      (country) => country.id == newValue
    );
    countryAddressShow.value = allCountries.value[countryIndex].name;
  }



  axios
    .get(props.baseURL + "states/" + newValue)
    .then((response) => {
      allStates.value = response.data.states;
      console.log("states  data", response.data.states);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
});

watch(state, (newValue, oldValue) => {
  // Only fetch tax if a valid state is selected
  if (!newValue || newValue === "") {
    // Clear tax when no state is selected
    cartData.clearTax();
    console.log("No state selected, tax cleared");
    return;
  }

  if (allStates.value.length > 0) {
    let stateIndex = allStates.value.findIndex(
      (country) => country.id == newValue
    );
    console.log("allStates stateIndex", stateIndex);
    console.log("allStates.value", allStates.value);
    stateAddressShow.value = allStates.value[stateIndex].name;
  }

  axios
    .get(props.baseURL + "tax/" + newValue)
    .then((response) => {
      //allStates.value = response.data.states;
      cartData.addTaxData(response.data);
      console.log("states tax data", response.data);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
});

watch(languageCode, () => {
  console.log("isLoggedIn ref changed, do something!");
  translatText();
});

watch(loginToken, () => {
  
  const headers = {
  Authorization: "Bearer " + userLogin.loggedToken,
};

  const apiUrl = props.baseURL + "user/address/shipping";
  axios
    .get(apiUrl, { headers })
    .then((response) => {
      console.log(
        "response user/address/shipping :",
        response.data.shipping_address
      );
      //translationText.value = response.data;
      if (response.data.shipping_address) {
        country.value = response.data.shipping_address.country;
        first_name.value = userLogin.getUserUserData.firstname;
        last_name.value = userLogin.getUserUserData.lastname;
        address1.value = response.data.shipping_address.address1;
        addres2.value = response.data.shipping_address.address2;
        city.value = response.data.shipping_address.city;
        state.value = response.data.shipping_address.state;
        zip_code.value = response.data.shipping_address.zip_code;
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
});

// Watch for route query parameter changes
watch(() => route.query.double, (newValue, oldValue) => {
  // If double parameter is removed (was 'true', now undefined or not 'true')
  if (oldValue === 'true' && newValue !== 'true') {
    console.log('BOGO parameter removed - clearing cart');
    cartData.resetAllData();
  }
});

// Watch for route changes (when user navigates away from checkout)
watch(() => route.path, (newPath, oldPath) => {
  // If user was on checkout with double=true and navigates away
  if (oldPath === '/checkout' && route.query.double !== 'true') {
    console.log('User navigated away from BOGO checkout - clearing cart');
    cartData.resetAllData();
  }
});

// Hook when user is about to leave the checkout route
onBeforeRouteLeave((to, from) => {
  // If leaving checkout page and double parameter was set
  if (from.query.double === 'true') {
    console.log('Leaving BOGO checkout - clearing cart');
    cartData.resetAllData();
  }
  return true; // Allow navigation
});

// Hook when route is updated (e.g., query parameters change)
onBeforeRouteUpdate((to, from) => {
  // If double parameter is being removed
  if (from.query.double === 'true' && to.query.double !== 'true') {
    console.log('BOGO parameter being removed - clearing cart');
    cartData.resetAllData();
  }
  return true; // Allow navigation
});

onMounted(async () => {
  // Show loading overlay when page is initializing
  isExpressCheckoutLoading.value = true;

  try {
    // IMPORTANT: Detect country FIRST before loading any payment SDKs
    // This ensures the PayPal SDK loads with the correct currency
    await detectCountryByIP();

    // ADD THIS CHECK - UnifiedExpressCheckout Integration
    if (!process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY) {
      console.warn('STRIPE_PUBLISHABLE_KEY is not set in environment variables');
    }
    // Get the product ID from the URL query parameter
    fetchDataFromAPIHolistic();
    const productId = route.query.product;
    const lang = route.query.lang;
    if (productId) {
      addProductToCart(productId);
      userLanguages.setLanguage({ code: lang });
      defaultLanguage.value = lang;
      getHeader(); // Update navigation headers
      console.log(`Language set to: ${lang}`);

      getLanguage();
    }
    getCountry();
    translatText();
    if (userLogin.getUserUserData != null) {
      email.value = userLogin.getUserUserData.email;
      getUserAddress();
    }

    setTimeout(() => {
      addTrackingScript();
      addFacebookPixel();
    }, 1000);

    //checkAutoshipRestriction();

    // Hide loading overlay after a short delay to ensure page is rendered
    setTimeout(() => {
      isExpressCheckoutLoading.value = false;
    }, 800);

  } catch (error) {
    console.error('Error during checkout initialization:', error);
    // Hide loading overlay even if there's an error
    isExpressCheckoutLoading.value = false;
  }
});

const paymentSection = ref(null);

function selectAndScroll(method) {
  nextTick(() => {
    if (paymentSection.value) {
      paymentSection.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.warn('paymentSection is not available');
    }
  });
}


watch(() => route.query.lang, (newLang) => {
  if (newLang) {
    userLanguages.setLanguage({ code: newLang });
    defaultLanguage.value = newLang;
    getHeader(); // Update navigation headers
    console.log(`Language updated to: ${newLang}`);
  }
  getLanguage();
});

//EXPRESS CHECKOUT

// Express Checkout computed properties
const stripePublishableKey = computed(() => {
  return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || '';
});

const expressCheckoutItems = computed(() => {
  const cartItems = cartData.getCartItems;
  console.log('🔍 Raw cart items for express checkout:', cartItems);
  
  let items = [];
  if (Array.isArray(cartItems)) {
    items = cartItems;
  } else if (cartItems && cartItems.value && Array.isArray(cartItems.value)) {
    items = cartItems.value;
  }
  
  const formattedItems = items.map((item, index) => ({
    id: item.id || index + 1,
    name: item.name || `Product ${index + 1}`,
    price: parseFloat(item.price || item.sale_price || 0),
    quantity: parseInt(item.quantity || 1),
    description: item.description || item.short_description || ''
  }));
  
  console.log('🔍 Formatted items for express checkout:', formattedItems);
  return formattedItems;
});

const expressCheckoutAmount = computed(() => {
  const cartItems = cartData.getCartItems;
  if (!cartItems) return 0;
  
  let items = Array.isArray(cartItems) ? cartItems : (cartItems.value || []);
  
  const subtotal = items.reduce((total, item) => {
    const price = item.price || item.sale_price || 0;
    const quantity = item.quantity || 1;
    return total + (price * quantity);
  }, 0);
  
  // For express checkout, we're using free shipping
  const totalAmount = subtotal;
  
  console.log('🔍 Amount calculation for express checkout:', {
    subtotal,
    totalAmount
  });
  
  return totalAmount > 0 ? totalAmount : 0;
});

const expressCheckoutCurrency = computed(() => {
  // For express checkout, ONLY use IP geolocation currency
  // This ensures currency is based on the customer's actual location, not user-selected country

  // ONLY Check IP geolocation detected currency
  if (detectedCurrency.value) {
    console.log('🔍 expressCheckoutCurrency - Using IP geolocation currency:', detectedCurrency.value);
    console.log('%c💰 EXPRESS CHECKOUT CURRENCY: ' + detectedCurrency.value, 'background: #ff6347; color: #fff; font-size: 18px; padding: 8px;');
    return detectedCurrency.value;
  }

  // Default to USD if IP detection fails
  console.log('🔍 expressCheckoutCurrency - No IP detection, defaulting to USD');
  console.log('%c💰 EXPRESS CHECKOUT CURRENCY: USD (fallback)', 'background: #ff6347; color: #fff; font-size: 18px; padding: 8px;');
  return "USD";
});

const expressCheckoutCountry = computed(() => {
  return userLogin.getUserCountry;
});
const expressCheckoutUserId = computed(() => {
  if (userLogin.checkIsLoggedIn && userLogin.getUserUserData) {
    const userData = userLogin.getUserUserData;
    return userData.id || userData.user_id || userData.userId || 999999;
  }
  return 999999; // Guest user ID
});
const expressCheckoutReferralId = computed(() => {  

  if (userLogin.checkIsLoggedIn && userLogin.getUserUserData) {    
    return userLogin.getUserUserData.id || userLogin.getReferalId;
  }
  return userLogin.getReferalId;
});

const expressCheckoutShippingAddress = computed(() => {
  // For express checkout, shipping address will be captured from payment provider
  return null;
});

const canUseExpressCheckout = computed(() => {
  const hasItems = expressCheckoutItems.value.length > 0;
  const hasAmount = expressCheckoutAmount.value > 0;
  
  // Check if any item has autoship
  const hasAutoshipItems = cartData.getCartPurchaseType;
  
  return hasItems && hasAmount && !hasAutoshipItems;
});
/*
const checkAutoshipRestriction = () => {
    console.log("checkAutoshipRestriction", cartData.getCartPurchaseType);
  if(cartData.getCartPurchaseType == true) {
      swal({
        position: "center",
        icon: "error", 
        title: `Autoship restriction`,
        text: `Express checkout is not available for autoship products.`,
        button: "Try Again",
        timer: false,
      }).then(() => {
        router.push({ name: 'checkout' });
      });
  }
};*/



// Page loading state for express checkout
const isExpressCheckoutLoading = ref(false);

// Express checkout event handlers
const handleExpressPaymentSuccess = (data) => {
  console.log('🎊 [PARENT_SUCCESS_HANDLER] Express payment successful event received!')
  console.log('🎊 [PARENT_SUCCESS_HANDLER] Data received:', data);

  // Show loading overlay
  isExpressCheckoutLoading.value = true;

  // Reset cart first
  console.log('🛒 [PARENT_SUCCESS_HANDLER] Resetting cart...')
  cartData.$reset();

  // Redirect immediately to payment success page
  console.log('✅ [PARENT_SUCCESS_HANDLER] Redirecting to PaymentSuccess page...')
  setTimeout(() => {
    router.push({ name: 'PaymentSuccess' });
  }, 500);

  console.log('🎊 [PARENT_SUCCESS_HANDLER] Success handler completed')
};


const handleExpressPaymentError = (error) => {
  console.error('Express payment error:', error);
  
  // Show error message
  swal({
    position: "center",
    icon: "error",
    title: "Payment Failed",
    text: error.error || 'An error occurred during payment. Please try again.',
    button: "Try Again",
    timer: false,
  });
};

// Add Google Pay and Apple Pay SDK loading
const loadPaymentSDKs = () => {
  // Load Google Pay SDK
  if (!document.querySelector('script[src*="pay.google.com"]')) {
    const googlePayScript = document.createElement('script');
    googlePayScript.src = 'https://pay.google.com/gp/p/js/pay.js';
    googlePayScript.async = true;
    document.head.appendChild(googlePayScript);
  }
  
  // Apple Pay is browser native, no script needed
  console.log('Payment SDKs loading initiated');
};

onMounted(() => {
  loadPaymentSDKs();
  
  // Add tracking scripts (keep your existing tracking code)
  setTimeout(() => {
    // Your existing tracking code
  }, 1000);
});



</script>


<!-- <script>

import CheckoutProductReview from '../../components/Checkout/CheckoutProductReview';
import Payment from '../../components/Checkout/Payment';
export default {
    components : {CheckoutProductReview,Payment},
  data() {
    return {
      stripeAPIToken: process.env.VUE_APP_STRIPETOKEN,
      stripe: '',
      token: null,
      sessionId: null,
      checkoutBodyArray: [],
    };
  },

  name: 'Checkout',
  props: ['baseURL'],
  methods: {
    /*
      Configures Stripe by setting up the elements and
      creating the card element.
    */
    // configureStripe() {},

    // getAllItems() {
    //   axios.get(`${this.baseURL}cart/?token=${this.token}`).then(
    //     (response) => {
    //       if (response.status == 200) {
    //         let products = response.data;
    //         let len = Object.keys(products.cartItems).length;
    //         for (let i = 0; i < len; i++)
    //           this.checkoutBodyArray.push({
    //             imageUrl: products.cartItems[i].product.imageURL,
    //             productName: products.cartItems[i].product.name,
    //             quantity: products.cartItems[i].quantity,
    //             price: products.cartItems[i].product.price,
    //             productId: products.cartItems[i].product.id,
    //             userId: products.cartItems[i].userId,
    //           });
    //       }
    //     },
    //     (err) => {
    //       console.log(err);
    //     }
    //   );
    // },

    // goToCheckout() {
    //   axios
    //     .post(
    //       this.baseURL + 'order/create-checkout-session',
    //       this.checkoutBodyArray
    //     )
    //     .then((response) => {
    //       localStorage.setItem('sessionId', response.data.sessionId);
    //       return response.data;
    //     })
    //     .then((session) => {
    //       return this.stripe.redirectToCheckout({
    //         sessionId: session.sessionId,
    //       });
    //     });
    // },
  },
  mounted() {
    // get the token
    this.token = localStorage.getItem('token');
    // get all the cart items
    //this.stripe = Stripe(this.stripeAPIToken);
    console.log("stripe token",this.stripeAPIToken);
    //this.getAllItems();
  },
};
</script> -->

<style>
.alert {
  width: 50%;
}

.div_class {
  margin-top: 5%;
  margin-left: 30%;
}

.checkout_button {
  background-color: #5d3dec;
  border: none;
  color: white;
  margin-left: 15%;
  padding: 15px 30px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
  border-radius: 15px;
}

.checkout_button:focus {
  outline: none;
  box-shadow: none;
}

.checkout_button:disabled {
  background-color: #9b86f7;
  border: none;
  color: white;
  margin-left: 15%;
  padding: 15px 30px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
  border-radius: 15px;
  cursor: not-allowed;
}
.btn-checkout {
  margin-left: 9px;
  float: left;
  width: 175px;
}
form .payment-information .input-icon .stripeicon {
    position: absolute;
    right: 10px;
    top: 0;
    width: 240px;
    bottom: 0;
    margin: auto;
}
.checkout-process .label-heading h4 {
  text-transform: none !important;
}
.checkout-process .form-content {
    padding: 20px;
background-color: #fcfcfc;
 margin-bottom: 20px;
 border-radius: 10px;
 box-shadow: 0px 3px 10px rgba(0,0,0,0.1);
}
.order-review {background: #fcfcfc;
 padding: 30px;
    box-shadow: 0 2px 10px rgba(80, 80, 80, 0.1);
    border-radius: 10px;
}
.order-review {
    background: #fcfcfc;
    padding: 30px;
    box-shadow: 0 2px 10px rgba(80, 80, 80, 0.1);
    border-radius: 10px;
}
.checkout-sec .title h3{
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    color: #101010;
    display: inline-block;
    position: relative;
    margin-bottom: 20px;
    border-bottom: 3px solid #78cbc0;
    padding-bottom: 8px;
}

.checkout-sec .checkout-process .form-content {
  padding: 20px !important;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,.2);
  border: 2px solid #fff !important;
}

.checkout-sec .checkout-process .label-heading .link{
    font-family: "Montserrat", sans-serif;
}
.checkout-sec .checkout-process h4{
    text-transform: capitalize;
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    color: #101010;
    margin-bottom: 14px;
    font-size: 23px;
}
.checkout-sec .checkout-process .form-infomation{
    margin-bottom: 10px;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
}
.checkout-sec .checkout-process .form-infomation p{
    color: #4d4d4d;
    font-family: "Montserrat", sans-serif;
}
.checkout-sec .checkout-process .form-control{
    border-radius: 8px;
    border: 1px solid #8a8f93;
    background-color: #fff;
    font-family: "Montserrat", sans-serif;
}

.checkout-sec .form-input .field select.form-control{
    padding-top: 7px;
    margin-top: 16px;
}
.checkout-sec .form-input .field .field-label{
    font-size: 15px;
    color: #676767;
    background-color: #fff;
    font-family: "Montserrat", sans-serif;
    padding: 0 5px;
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f5f5f5+0,ffffff+100 */
    background: linear-gradient(to bottom,  #f5f5f5 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
.checkout-sec .custome_checkbox label{
    font-family: "Montserrat", sans-serif;
    color: #343434;
}
.checkout-sec .checkout-process .btn.rc {
    display: flex;
    justify-content: space-between;
    width: 210px;
    padding: 12px 20px;
    margin-top: 40px;
    border-radius: 30px;
}


.checkout-sec .order-review{
    padding: 25px !important;
    background-color: #f5f5f5;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: 0 3px 10px rgba(0,0,0,.2);
    border: 2px solid #fff !important;
}
.checkout-sec .order-review table .coupon input{
    border-radius: 8px;
    border: 1px solid #8a8f93;
    background-color: #fff;
    font-family: "Montserrat", sans-serif;
}
.checkout-sec .order-review .coupon .btn-dark{
    border-radius: 8px;
    font-family: "Montserrat", sans-serif
}
.checkout-sec .order-review table{
    font-family: "Montserrat", sans-serif;
}
.payment-options {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

#paypal-button-container {
  margin-top: 10px;
}

.payment-options {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

#paypal-button-container {
  margin-top: 10px;
}
.payment-information {
  border: 1px solid #636363;
  border-radius: 10px;
}
.payment-information .input-icon .StripeElement{
    border-radius: 8px;
  border: 1px solid #8a8f93;
  background-color: #fff;
  font-family: "Montserrat", sans-serif;
  max-width: 300px;
  padding: 10px;
}
.payment-information .form-group .input-icon .StripeElement{
    border-radius: 8px;
  border: 1px solid #8a8f93;
  background-color: #fff;
  font-family: "Montserrat", sans-serif;
  max-width: 150px;
  padding: 10px;
}
form .payment-information {
  border: 0px !important;
}
.payment-information .form-group .input-icon .StripeElement{
    border-radius: 8px;
  border: 1px solid #8a8f93;
  background-color: #fff;
  font-family: "Montserrat", sans-serif;
  max-width: 250px;
  padding: 10px;
}
.payment-information .form-group .StripeElement{
    border-radius: 8px;
  border: 1px solid #8a8f93;
  background-color: #fff;
  font-family: "Montserrat", sans-serif;
  max-width: 250px;
  padding: 10px;
}
.payment-method .row > div{
    display: flex;
  flex-wrap: wrap;
}
.payment-method .row > div .col-md-4{
    margin-right: 10px;
}
.extra-top{
    text-align: center;
}
.checkout-wrapper {
      max-width: 600px;
      margin: auto;
      text-align: center;
    }

    .checkout-wrapper h2 {
      font-size: 14px;
      margin-bottom: 20px;
      color: #777;
      text-transform: uppercase;
    }

    .payment-buttons {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 25px;
    }

    .payment-button {
      flex: 1;
      height: 48px;
      border: none;
      border-radius: 5px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
    }

    .payment-button img {
      max-height: 28px;
      object-fit: contain;
    }

    .paypal {
      background-color: #e9bc52;
    }

    .gpay {
      background-color: #000;
    }

    .apple-pay {
      background-color: #000;
    }

    .divider {
      display: flex;
      align-items: center;
      text-align: center;
      margin: 25px 0;
      color: #888;
      font-size: 13px;
    }

    .divider::before,
    .divider::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #ccc;
    }

    .divider:not(:empty)::before {
      margin-right: .75em;
    }

    .divider:not(:empty)::after {
      margin-left: .75em;
    }
    form .payment-information .payment-method {
      border-bottom: none !important;
    }
    .payment-buttons-top {
    display: inline-block !important;
}
.payment-buttons-top .payment-button{
    width: 286px !important;
  margin: 10px 10px 0px 0;
  display: inline-block !important;
}
checkout-wrapper {
    max-width: 100% !important;
}
.payment-buttons-top .payment-button {
    width: 190px !important;    
}

/* Keep all your existing styles and add these for express checkout */

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 25px 0;
  color: #888;
  font-size: 14px;
  font-weight: 600;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 2px solid #ddd;
}

.divider:not(:empty)::before {
  margin-right: 1em;
}

.divider:not(:empty)::after {
  margin-left: 1em;
}

.payment-buttons-top .payment-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.payment-buttons-top .payment-button:disabled img {
  opacity: 0.5;
}

.checkout-wrapper h2 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
  font-weight: 600;
}

/* Express Checkout Loading Overlay */
.express-checkout-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.express-loading-content {
  text-align: center;
}

.express-loading-spinner {
  width: 70px;
  height: 70px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #0070ba;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 30px;
}

.express-loading-text {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.express-loading-subtext {
  font-size: 14px;
  color: #666;
  margin: 0;
  font-family: "Montserrat", sans-serif;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


@media only screen and (max-width: 1400px) {


}
    
@media only screen and (max-width: 1199px) {
form .payment-information .input-icon .stripeicon {
    position: relative !important;
}

}
.flash-sale h2 {
    color: red;
    line-height: inherit;
    margin-bottom: 0px;;
}
.flash-sale {
  margin-bottom: 20px;
}
</style>
